import request from '@/utils/seftRequest';

// 获取staff用户信息
export async function qryLoginStaffInfo(params) {
  return request('/login/queryLoginStaffInfo', {
    params,
  });
}

// 获取org信息
export async function qryLoginOrgInfo(params) {
  return request('/ding/channel/queryCurrentOrg', {
    params,
  });
}

// 查询证件类型列表
export function qryCertType(params) {
  return request('/ding/custService/qryCertType', {
    params,
  });
}

// 查询客户
export function qryCustList(params) {
  return request('/ding/custService/qryCustListBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询服务类型和子服务类型
export function qryServiceType(params) {
  return request('/ding/custService/qryServiceTypeBsnl', {
    params,
  });
}

export function qryServiceTypeByFr(params) {
  return request('/ding/custService/qryServiceTypeByFr', {
    params,
  });
}

// 查询订户列表
export function qrySubsList(params) {
  return request('/ding/subsService/qrySubsListBsnl', {
    params,
  });
}

// BPAY自注册状态校验接口
export function frBpayStateCheck(params) {
  return request('/ding/channel/frBpayStateCheck', {
    params,
  });
}
